export default __webpack_public_path__ + "static/media/trust-charity.92f3a101.svg";